/**
 * Domatik Parser v1.0
 * Metin içindeki miktar, birim ve ismi ayırır.
 * Kural: "Domates 2kg" -> { name: "Domates", amount: 2, unit: "kg" }
 */
export const parseSmartInput = (text) => {
    if (!text) return { name: '', amount: null, unit: null };

    // Kullanıcının önerdiği regex: (.+?)\s+(\d+(?:[.,]\d+)?)\s*(kg|g|lt|l|adet)?$/i
    const match = text.match(/(.+?)\s+(\d+(?:[.,]\d+)?)\s*(kg|g|lt|l|adet|demet|paket|su bardağı|yemek kaşığı)?$/i);

    if (!match) {
        return { name: text.trim(), amount: null, unit: null };
    }

    return {
        name: match[1].trim(),
        amount: parseFloat(match[2].replace(',', '.')),
        unit: match[3] || null
    };
};
